import { LayersControl } from 'react-leaflet'
import BaseLayers from './BaseLayers'
import DrawingLayers from './DrawingLayers'
import EligibilityLayers from './EligibilityLayers'

const MapElements = ({
  carbonInstancesByMonitoringPeriod,
  center,
  drawingType,
  eligibilityAreas,
  etapa,
  exclusionAreas,
  handleEtapa,
  handleExclusionAreas,
  handleMapUpdate,
  handleMonitoringSites,
  handleOtherPolygons,
  handleOtherSites,
  handlePaddocks,
  handlePerimeter,
  handleSamplingAreas,
  handleUnassigned,
  handleUnassignedPoints,
  map,
  mapUpdate,
  monitoringSites,
  otherPolygons,
  otherSites,
  paddocks,
  perimeter,
  samplingAreas,
  unassigned,
  unassignedPoints,
}) => {
  return (
    <LayersControl collapsed={false} position="topright">
      <BaseLayers />
      <DrawingLayers
        carbonInstancesByMonitoringPeriod={carbonInstancesByMonitoringPeriod}
        center={center}
        drawingType={drawingType}
        etapa={etapa}
        exclusionAreas={exclusionAreas}
        handleEtapa={handleEtapa}
        handleExclusionAreas={handleExclusionAreas}
        handleMapUpdate={handleMapUpdate}
        handleMonitoringSites={handleMonitoringSites}
        handleOtherPolygons={handleOtherPolygons}
        handleOtherSites={handleOtherSites}
        handlePaddocks={handlePaddocks}
        handlePerimeter={handlePerimeter}
        handleSamplingAreas={handleSamplingAreas}
        handleUnassigned={handleUnassigned}
        handleUnassignedPoints={handleUnassignedPoints}
        map={map}
        mapUpdate={mapUpdate}
        monitoringSites={monitoringSites}
        otherPolygons={otherPolygons}
        otherSites={otherSites}
        paddocks={paddocks}
        perimeter={perimeter}
        samplingAreas={samplingAreas}
        unassigned={unassigned}
        unassignedPoints={unassignedPoints}
      />
      <EligibilityLayers eligibilityAreas={eligibilityAreas} />
    </LayersControl>
  )
}

export default MapElements
